/* PROJ-110 Q4 (12.10.2026): Vorteils-Band im Warenkorb (snippets/dm-usp-band.liquid).
   Eigene Datei, weil der Drawer per HTML-Austausch neu gerendert wird und Inline-Skripte dann nicht laufen;
   geladen ganz oben in sections/cart-drawer.liquid, also auch bei leerem Warenkorb. */
/* Logik 1:1 aus Tierliebhabers ShUspSlider (Autoplay, Pfeile, Punkte, Pause bei Hover/Fokus/Tab verdeckt). */
if (!customElements.get('dm-usp-slider')) {
  customElements.define('dm-usp-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-dm-usp-track]');
      this.slides = this.track ? Array.from(this.track.children) : [];
      this.dots = Array.from(this.querySelectorAll('[data-dm-usp-dots] > *'));
      if (!this.track || this.slides.length < 2) return;
      this.index = 0; this.timer = null; this.paused = false;
      this.interval = parseInt(this.dataset.autoplay, 10) || 4000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.onPrev = () => { this.goTo(this.index - 1); this.play(); };
      this.onNext = () => { this.goTo(this.index + 1); this.play(); };
      this.onPause = () => { this.paused = true; this.stop(); };
      this.onResume = () => { this.paused = false; this.play(); };
      this.onVisibility = () => { document.hidden ? this.stop() : this.play(); };
      const prev = this.querySelector('[data-dm-usp-prev]'), next = this.querySelector('[data-dm-usp-next]');
      if (prev) prev.addEventListener('click', this.onPrev);
      if (next) next.addEventListener('click', this.onNext);
      this.addEventListener('mouseenter', this.onPause);
      this.addEventListener('mouseleave', this.onResume);
      this.addEventListener('focusin', this.onPause);
      this.addEventListener('focusout', this.onResume);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.goTo(0); this.play();
    }
    disconnectedCallback() { this.stop(); document.removeEventListener('visibilitychange', this.onVisibility); }
    goTo(target) {
      const count = this.slides.length;
      this.index = ((target % count) + count) % count;
      this.track.style.transform = 'translateX(-' + this.index * 100 + '%)';
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
    }
    play() { this.stop(); if (!this.reducedMotion && !this.paused) this.timer = setInterval(() => this.goTo(this.index + 1), this.interval); }
    stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
  });
}
